import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ConfirmDialogResponse } from "~app/common/models/constants";
import { CommonTexts } from "~app/common/texts/common.texts";
import { ButtonComponent } from "../../button/button.component";
import { MessagePanelComponent } from "../../message-panel/message-panel.component";
import { IMessageModel } from "../../message-panel/message-panel.models";

@Component({
    selector: "rask-confirm-modal-component",
    styleUrls: ["./confirm.component.scss"],
    templateUrl: "./confirm.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ButtonComponent,
        MessagePanelComponent
    ]
})
export class ConfirmModalComponent implements OnInit {
    activeModal = inject(NgbActiveModal);

    content: string;
    contentIsMarkup = false;
    messages: IMessageModel[] = [];
    yesCaption: string;
    noCaption: string;
    yesDisabled: boolean;
    commonTexts = CommonTexts.texts;
    saved = ConfirmDialogResponse.save;
    cancel = ConfirmDialogResponse.cancel;
    ngOnInit(): void {
        document.getElementById("cancel").focus();
    }

}
